import React from "react";
import "./css/GoalSection.css";


export default function GoalsSection() {
return (
<div className="goals-container">
<div className="goals-header">
{/* <img src="/images/leaf_icon.png" alt="leaf" className="leaf-icon" /> */}
<h2>🌱 आमची उद्दिष्टे</h2>
</div>


<div className="goals-wrapper">
<div className="goal-box">प्रत्येक कुटुंबापर्यंत शासानाच्या योजना पोहोचवणे</div>
<div className="goal-box">शिक्षण, आरोग्य आणि रोजगाराच्या संधी वाढवणे</div>
<div className="goal-box">हरित आणि स्वच्छ नगरी निर्माण करणे</div>
<div className="goal-box">ग्रामपंचायतीच्या कार्यात पारदर्शकता आणि लोकसहभाग वाढवणे</div>
</div>
</div>
);
}